import { atom } from 'recoil';
import { ATOMS_KEYS } from '../atom-keys';

export const controleAdvancedSettings = atom<boolean>({
	key: ATOMS_KEYS.CONTROLEADVANCEDSETTINGS,
	default: false,
});
